export class AppConfig {

    // Fonerwa server
    public readonly apiUrl = 'http://197.243.20.164/';
    // public readonly apiUrl = 'http://197.243.20.156:8081/';
    // public readonly apiUrl = 'http://10.10.77.153/';

    // tiger server
    // public readonly apiUrl = 'http://197.243.22.168:9085/';

    // nida server
    public readonly NIDapiUrl = 'https://uat.nida.gov.rw:8081/';
    // token and session 
    public readonly JWT_Token = 'GCF-Projects-MIS';
    public readonly Session_User = 'UserData';
    public readonly valide_User = 'session';
}


